import { useCallback, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { invokeEdgeFunction } from '@/utils/supabase-functions';

export interface AffiliatedAdvisor {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
}

export interface ExistingClient {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  phone: string | null;
}

/**
 * Accessi dati del modale richiesta cliente: elenchi di supporto e le due
 * scritture (create-client-request / update-client-request).
 *
 * Sta qui e non nel componente perche' le chiamate a Supabase non vivono nei
 * componenti (CLAUDE.md).
 */
export const useClientRequestActions = () => {
  const [advisors, setAdvisors] = useState<AffiliatedAdvisor[]>([]);
  const [clients, setClients] = useState<ExistingClient[]>([]);

  const loadAdvisors = useCallback(async () => {
    // RPC SECURITY DEFINER: la RLS su public.users non concede all'agency la
    // visibilita' sulle righe travel_advisor_member, la query diretta tornerebbe vuota.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data, error } = await supabase.rpc('get_my_advisors' as any);
    if (error) throw error;
    setAdvisors((data as AffiliatedAdvisor[]) || []);
  }, []);

  const loadClients = useCallback(async () => {
    const { data, error } = await supabase
      .from('users')
      .select('id, email, first_name, last_name, phone')
      .eq('role', 'traveler')
      .order('first_name', { ascending: true });
    if (error) throw error;
    setClients(data || []);
  }, []);

  const createRequest = useCallback(async (body: unknown) => {
    return invokeEdgeFunction(supabase, 'create-client-request', { body });
  }, []);

  const updateRequest = useCallback(async (body: unknown) => {
    return invokeEdgeFunction(supabase, 'update-client-request', { body });
  }, []);

  return { advisors, clients, loadAdvisors, loadClients, createRequest, updateRequest };
};
